var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.2214 0H12.8C4.62934 0 0 4.62934 0 12.8V35.2001C0 43.3706 4.62934 48 12.8 48H35.2214C43.392 48 48 43.3706 48 35.2001V12.8C48 4.62934 43.392 0 35.2214 0Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3327 33.3333V37.3333H10.666V33.3333C10.666 32.6 11.266 32 11.9993 32H35.9994C36.7327 32 37.3327 32.6 37.3327 33.3333Z",
    fill: "#CE2600",
    stroke: "#CE2600",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M18.6673 22.666H13.334V31.9993H18.6673V22.666Z",
    fill: "#CE2600"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M23.9993 22.666H18.666V31.9993H23.9993V22.666Z",
    fill: "#CE2600"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M29.3333 22.666H24V31.9993H29.3333V22.666Z",
    fill: "#CE2600"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M34.6673 22.666H29.334V31.9993H34.6673V22.666Z",
    fill: "#CE2600"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6673 38.334H9.33398C8.78732 38.334 8.33398 37.8807 8.33398 37.334C8.33398 36.7873 8.78732 36.334 9.33398 36.334H38.6673C39.214 36.334 39.6673 36.7873 39.6673 37.334C39.6673 37.8807 39.214 38.334 38.6673 38.334Z",
    fill: "#CE2600"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4927 15.6671L24.4927 10.8671C24.226 10.7604 23.7727 10.7604 23.506 10.8671L11.506 15.6671C11.0393 15.8537 10.666 16.4004 10.666 16.9071V21.3337C10.666 22.0671 11.266 22.6671 11.9993 22.6671H35.9993C36.7327 22.6671 37.3327 22.0671 37.3327 21.3337V16.9071C37.3327 16.4004 36.9593 15.8537 36.4927 15.6671ZM23.9993 19.3337C22.8927 19.3337 21.9993 18.4404 21.9993 17.3337C21.9993 16.2271 22.8927 15.3337 23.9993 15.3337C25.106 15.3337 25.9993 16.2271 25.9993 17.3337C25.9993 18.4404 25.106 19.3337 23.9993 19.3337Z",
    fill: "#CE2600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankTransfer);
export default __webpack_public_path__ + "static/media/bank-transfer.1b72c5ae8a402af1c568d6ff9d64d7b9.svg";
export { ForwardRef as ReactComponent };